import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

// openlayers
import 'ol/ol.css'

// elementui
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'

// 引入echarts
import * as echarts from 'echarts'
Vue.prototype.$bus = new Vue() // 用于传递事件

Vue.config.productionTip = false
Vue.use(ElementUI)
Vue.prototype.$echarts = echarts

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
